/**
 * Helper to pull query data from locked GraphQL
 * @param query - GraphQL query string
 * @returns GraphQL query result or an empty array
 */
export async function getQuery(query: string, retries = 3): Promise<any> {
  if (!query) {
    return [];
  }

  const user = await getJWTUser();
  const headers: Record<string, string> = {};
  const notificationStore = useNotificationStore();

  if (user) {
    const token = getJWTUserToken();
    headers["Authorization"] = `Bearer ${token}`;
    headers["Content-Type"] = "application/json";
  }

  const config = useRuntimeConfig();
  const url = `${config.public.API_URL}${config.public.GRAPHQL_ROUTE}`;

  let attempt = 0;
  let lastError;

  while (attempt < retries) {
    try {
      const { data, error } = await $fetch<any>(url, {
        method: "POST",
        body: { query },
        headers,
        mode: "cors"
      });

      if (!error) {
        return data || [];
      }

      lastError = error;
      notificationStore.error({
        variant: "error",
        messageHead: `Fetch attempt ${attempt + 1} failed`,
        messageBody: String(error)
      });
    } catch (err) {
      lastError = err;
      notificationStore.error({
        variant: "error",
        messageHead: `Fetch attempt ${attempt + 1} threw`,
        messageBody: String(err)
      });
    }

    attempt++;
  }

  notificationStore.error({
    variant: "error",
    messageHead: "All fetch attempts failed:",
    messageBody: String(lastError)
  });

  return [];
}
